import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {AnalysisTab, CoverageAnalysisView} from '../rfi-coverage-analysis-dialog.types';
import {CoverageTabHeaderComponent} from '../coverage-tab-header/coverage-tab-header.component';
import {
  CoverageTableColumn,
  CoverageTableHeadComponent,
} from '../coverage-table-head/coverage-table-head.component';

const GAP_COLUMNS: CoverageTableColumn[] = [
  {labelKey: 'project.steps.rfi.invitationList.analysis.column.function'},
  {labelKey: 'project.steps.rfi.invitationList.analysis.column.country'},
  {labelKey: 'project.steps.rfi.invitationList.analysis.column.employees'},
  {labelKey: 'project.steps.rfi.invitationList.analysis.column.cause'},
  {labelKey: 'project.steps.rfi.invitationList.analysis.column.impact', numeric: true},
];

@Component({
  selector: 'app-coverage-gaps-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AppNumberPipe,
    TranslocoPipe,
    Button,
    CoverageTabHeaderComponent,
    CoverageTableHeadComponent,
  ],
  templateUrl: './coverage-gaps-tab.component.html',
})
export class CoverageGapsTabComponent {
  protected readonly columns = GAP_COLUMNS;

  readonly view = input.required<CoverageAnalysisView>();

  readonly tabRequested = output<AnalysisTab>();
}
